// 不動産種別のvalue
export enum RealEstateTypeValues {
  BUILDING = "BUILDING",
  CONDOMINIUM = "CONDOMINIUM",
  LAND = "LAND",
}

// 不動産種別のlabel
export enum RealEstateTypeLabels {
  BUILDING = "建物",
  CONDOMINIUM = "区分建物",
  LAND = "土地",
}

// 登記・図面種別のvalue
export enum PictureTypeValues {
  SHOYUSHAJIKO = "SHOYUSHAJIKO",
  ZENBUJIKO = "ZENBUJIKO",
}

// 登記・図面種別のlabel
export enum PictureTypeLabels {
  SHOYUSHAJIKO = "所有者事項",
  ZENBUJIKO = "全部事項",
}

// 登記原因の「その他」選択時のvalue
// BEのマスタには存在せず、FE側でのみ付加する選択肢のため、マスタ値と衝突しない文字列にする
export const OTHER_REASON_OPTION_VALUE = "__OTHER__";

// 登記原因の「その他」選択肢のlabel
// マスタ側にも「その他」というグループ名があるため、自由入力であることを明示する
export const OTHER_REASON_OPTION_LABEL = "その他（自由入力）";
